
import { Component, EventEmitter, OnInit, Output, ElementRef, ViewChild, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscriber } from 'rxjs';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { finalize } from 'rxjs/operators';
@Component({
  selector: 'app-document-details',
  templateUrl: './document-details.component.html',
  styleUrls: ['./document-details.component.scss']
})
export class DocumentDetailsComponent implements OnInit {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInput') fileInputRefs!: ElementRef[];
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  @Output() first = new EventEmitter<void>();
  @Input() tabName: string = '';
  dialogRef: MatDialogRef<any>;
  errormessage: string;
  uploadDoc: any;
  fileName: string;
  filePre: any;
  imgFile: any;
  ducumentList: any;
  isDivShow = false;
  errMsg: any;
  disabled = false;
  printDisabled = true;
  fileNameinput = true;
  isFileInputNot = true
  addmissionData: any;
  session: string;
  inputTimeout: any;
  StuSrNum
  StuDocName
  StuRmk
  InstId: any;
  formSubmitted = false;
  ducumentList2: any;
  SavedDocument = []
  DateDisable = false
  abc
  xyz
  DocErr: any;
  DocRecords: any[];
  selectedRow: any | null = null;
  valuesArray: any;
  isRedText: boolean;
  stuSrNoArray: string[] = [];
  tabs: string;
  displayName: any;
  PersonalDetails: any;
  addressDetails: any;
  ReservationDetails: any;
  ExamDtails: any;
  laterEntry: string;
  activeFlowObject: any;
  arrActiveFlow: any;
  constructor(private fb: FormBuilder, public router: Router,
    public umsService: UmsService, public datepipe: DatePipe,
    public dialog: MatDialog, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService) { }
  @ViewChild('fileUploader') fileUploader: ElementRef;
  documentDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  CoId;
  CgId;

  ngOnInit(): void {
    this.submitButton = true;
    this.updateButton = false;
    this.disabled = false
    this.prepopulationOfAddmission();
    this.session = sessionStorage.getItem('session');
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    let i = 0;
    this.documentDetailsForm = this.fb.group({
      "StuRemarkConfirm": new FormControl(''),
      "StuRemarkCheck": new FormControl('', Validators.required),
      arrData: this.fb.array([]),
    });

    this.prepopulationOfAddmission();
    // this.fetchDocument();
    this.fetchDocument2();
    this.getScrutiny();
    this.getSecretData()
    this.getPersonalDetails();
  }

  getScrutiny() {
    this.spinner.show();
    const payload = {};
    this.DocErr = []
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
      if (res.status) {
        this.spinner.hide();
        if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
          if (res.data[0].Tabs.includes('Document Upload')) {
            this.DocErr = res.data;
            this.disabled = false;
            this.printDisabled = true
            this.fileNameinput = true;
          } else {
            this.disabled = true;
            this.printDisabled = false
            this.fileNameinput = false;
          }
        }
        else {
          this.disabled = true;
          this.printDisabled = false
          this.fileNameinput = false;
        }

      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  fileUploads: string[] = [];

  onChange($event: Event, rowIndex: number) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;

    const faControl = (<FormArray>this.documentDetailsForm.controls['arrData']).at(rowIndex);

    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {
        message: this.errormessage,
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
      });
    } else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
      if (ext === "pdf") {
        this.convertToBase64(file, rowIndex);
        faControl['controls'].DocumentFile.setValue(fileName);
        faControl['controls'].DocumentFile.markAsTouched();
      } else {
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
        faControl['controls'].DocumentFile.markAsTouched();
        let data = {
          message: 'Please Upload Only PDF File',
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }


  convertToBase64(file: File, rowIndex: number) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      while (this.fileUploads.length <= rowIndex) {
        this.fileUploads.push(null);
      }
      this.fileUploads[rowIndex] = d;
      let base64Str = d.split(',');
      let filee = base64Str[1];
      const faControl = (<FormArray>this.documentDetailsForm.controls['arrData']).at(rowIndex);
      faControl['controls'].docFile.setValue(filee);
      faControl['controls'].DocumentFile.setValue(file.name);

    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }


  AddScrtDetails() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(this.session)
    payload['CgCode'] = this.CgId
    payload['CoCode'] = this.CoId
    this.umsService.AddScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.first.emit();
        this.NewCoSch();
      }
      else {

      }
    })
  }


  AddScrtDetails1() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(this.session)
    payload['CgCode'] = this.CgId
    payload['CoCode'] = this.CoId
    this.umsService.AddScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        this.first.emit();

      }
      else {

      }
    })
  }

  UpdScrtDetails() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(this.session)
    payload['CgCode'] = this.CgId
    payload['CoCode'] = this.CoId
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        this.first.emit();
        location.reload();
      }
      else {

      }
    })
  }


  saveApplicationDetails() {
    // const currentDate = new Date();
    // const formattedDate = currentDate.toISOString().slice(0, 10);
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['SessionId'] = this.session
    payload['CgCode'] = this.CgId
    payload['CoCode'] = this.CoId
    payload['ApplicationName'] = 'Registration'
    // payload['ApplicationSubDate'] = formattedDate
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    })
  }

  fetchDocument() {
    this.spinner.show()
    let payload = {};
    payload['StudentID'] = this.StudentPersonalId;
    this.umsService.fetchStudDocumentDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.ducumentList = res.data;
        if (this.SavedDocument.length == 0) {
          this.submitButton = true
          this.updateButton = false
          this.disabled = false
          this.isDivShow = false;
          const documentsArray = this.documentDetailsForm.get('arrData') as FormArray;
          const arrayOfObjects = res.data;
          const documentFormGroup = this.fb.group({
            arrData: this.fb.array([]),
          });
          arrayOfObjects.forEach((obj, i) => {
            const tempObj = {}
            let regex = '';
            if (obj.RegEx !== null) {
              regex = obj.RegEx
            }
            const validators = (obj.IsRequired && obj.RegEx != null) ? [Validators.required, Validators.pattern(obj.RegEx)] : (obj.IsRequired && obj.RegEx == null) ? [Validators.required] : [];
            const validators1 = (obj.IsRequired && obj.HasExpiryDate) ? [Validators.required] : [];
            const validators2 = obj.IsRequired ? [Validators.required] : [];
            tempObj['DocumentID'] = new FormControl(obj.DocumentID),
              tempObj['DocumentName'] = new FormControl(obj.DocumentName),
              tempObj['IsRequired'] = new FormControl(obj.IsRequired),
              tempObj['HasExpiryDate'] = new FormControl(obj.HasExpiryDate),
              tempObj['IsConditional'] = new FormControl(obj.IsConditional),
              tempObj['ConditionField'] = new FormControl(obj.ConditionField),
              tempObj['ConditionValue'] = new FormControl(obj.ConditionValue),
              tempObj['RegEx'] = new FormControl(obj.RegEx),
              tempObj['SortSequence'] = new FormControl(obj.SortSequence),
              tempObj['docFile'] = new FormControl(''),
              tempObj['docNo'] = new FormControl(''),
              tempObj['StuSrNo'] = new FormControl(''),
              tempObj['DocumentFile'] = new FormControl('', validators),
              tempObj['StuDocIssue'] = new FormControl('', validators1),
              tempObj['StuDocExpiry'] = new FormControl('', validators1)
            for (const key in tempObj) {
            }
            const creds = this.documentDetailsForm.controls.arrData as FormArray;
            creds.push(new FormGroup(tempObj));
          })
        } else {
          this.submitButton = false
          this.updateButton = true
          this.isDivShow = true;
          // this.umsService.disable8 = false;
          const documentsArray = this.documentDetailsForm.get('arrData') as FormArray;
          const arrayOfObjects = res.data;
          const documentFormGroup = this.fb.group({
            arrData: this.fb.array([]),
          });
          arrayOfObjects.forEach((obj, i) => {
            const tempObj = {}
            let regex = '';
            if (obj.RegEx !== null) {
              regex = obj.RegEx
            }
            let StuRemarkCheck = false;
            if (this.SavedDocument[0].StuRemarkCheck == 1) {
              StuRemarkCheck = true;
            } else {
              StuRemarkCheck = false;
            }
            if (this.SavedDocument[i].StuDocIssue == "1900-01-01" && this.SavedDocument[i].StuDocExpiry == "1900-01-01") {
              this.abc = '';
              this.xyz = '';
            }
            else if (this.SavedDocument[i].StuDocIssue == "1900-01-01") {
              this.abc = '';

            }
            else if (this.SavedDocument[i].StuDocExpiry == "1900-01-01") {

              this.xyz = '';
            }
            else {
              this.abc = this.SavedDocument[i].StuDocIssue;
              this.xyz = this.SavedDocument[i].StuDocExpiry;
            }
            const validators = (obj.IsRequired && obj.RegEx != null) ? [Validators.required, Validators.pattern(obj.RegEx)] : (obj.IsRequired && obj.RegEx == null) ? [Validators.required] : [];
            const validators1 = (obj.IsRequired && obj.HasExpiryDate) ? [Validators.required] : [];
            const validators2 = obj.IsRequired ? [Validators.required] : [];
            tempObj['DocumentID'] = new FormControl(obj.DocumentID),
              tempObj['DocumentName'] = new FormControl(obj.DocumentName),
              tempObj['IsRequired'] = new FormControl(obj.IsRequired),
              tempObj['HasExpiryDate'] = new FormControl(obj.HasExpiryDate),
              tempObj['IsConditional'] = new FormControl(obj.IsConditional),
              tempObj['ConditionField'] = new FormControl(obj.ConditionField),
              tempObj['ConditionValue'] = new FormControl(obj.ConditionValue),
              tempObj['RegEx'] = new FormControl(obj.RegEx),
              tempObj['SortSequence'] = new FormControl(obj.SortSequence),
              tempObj['docFile'] = new FormControl(''),
              tempObj['docNo'] = new FormControl('')
            tempObj['StuSrNo'] = new FormControl(this.SavedDocument[i].StuSrNo),
              tempObj['DocumentFile'] = new FormControl(this.SavedDocument[i].StuFileUpload),
              tempObj['StuDocIssue'] = new FormControl(this.abc, validators1),
              tempObj['StuDocExpiry'] = new FormControl(this.xyz, validators1)
            tempObj['StuRemarkConfirm'] = new FormControl(this.SavedDocument[0].StuRemarkConfirm);
            tempObj['StuRemarkCheck'] = new FormControl(this.SavedDocument[0].StuRemarkCheck);

            for (const key in tempObj) {
            }
            const creds = this.documentDetailsForm.controls.arrData as FormArray;
            creds.push(new FormGroup(tempObj));
          })
          if (this.DocErr.length > 0) {
            let stusrno = this.DocErr[0]['StuSrNo'];
            this.valuesArray = stusrno.split(',');
          }
        }
      }
      else {
        //this.isPrepopulationEmpty = true;
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  checkcolor(id): any {
    if (id.value['StuSrNo'] == '' || id.value['StuSrNo'] == null) {
      let stuSrNoString = id.value['StuSrNo']
      if (this.valuesArray && this.valuesArray.includes(stuSrNoString)) {
        this.isRedText = true;
      }
      else {
        this.isRedText = false;
      }
    }
    else {
      let stuSrNoString = id.value['StuSrNo'].toString();
      if (this.valuesArray && this.valuesArray.includes(stuSrNoString)) {
        this.isRedText = true;
      }
      else {
        this.isRedText = false;
      }

    }



  }


  fetchDocument2() {
    // this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide();
        this.ducumentList2 = res.data;
        this.SavedDocument = this.ducumentList2;
        this.documentDetailsForm.controls['StuRemarkConfirm'].setValue(res.data[0].StuRemarkConfirm);
        this.documentDetailsForm.controls['StuRemarkCheck'].setValue(res.data[0].StuRemarkCheck);
        if (res.data.length == 0) {
          this.isDivShow = false;
        }
        else {
          this.isDivShow = true;
          // this.umsService.disable8 = false;
        }
        this.fetchDocument();
      } else {
        this.fetchDocument();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.fetchDocument();
    });
  }

  fetchForupdate(data) {
    this.spinner.show();
    this.updateButton = true;
    this.submitButton = false;
    let payload = {};
    payload['StuId'] = data.StuId;
    payload['StuDocId'] = data.StuDocId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {

      if (res.status) {
        this.spinner.hide()
        let data = res.data[0];
        sessionStorage.setItem('StuDocId', data.StuDocId)
        let StuRemarkCheck = false;
        if (data.StuRemarkCheck == 1) {
          StuRemarkCheck = true;
        } else {
          StuRemarkCheck = false;
        }

        let preArr = [];
        const tmpDict = {};
        tmpDict['StuId'] = new FormControl(data.StuId);
        tmpDict['StuSrNo'] = new FormControl(data.StuSrNo);
        tmpDict['StuDocumentName'] = new FormControl(data.StuDocumentName),
          tmpDict['StuRemark'] = new FormControl(data.StuRemark);
        tmpDict['StuFileUpload'] = new FormControl(data.StuFileUpload);
        tmpDict['StuRemarkConfirm'] = new FormControl(data.StuRemarkConfirm);
        tmpDict['StuRemarkCheck'] = new FormControl(data.StuRemarkCheck);
        tmpDict['CoCode'] = new FormControl(this.CoId);
        tmpDict['CgCode'] = new FormControl(this.CgId);
        tmpDict['StuDocExpiry'] = new FormControl(data.StuDocExpiry);
        tmpDict['StuDocIssue'] = new FormControl(data.StuDocIssue);
        const creds = this.documentDetailsForm.controls.arrData as FormArray;
        creds.push(new FormGroup(tmpDict));
      } else {
        this.spinner.hide();
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });

  }
  // getTabName(e) {
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }

  update() {
    const creds = this.documentDetailsForm.get('arrData') as FormArray;
    if (creds.invalid || this.documentDetailsForm.invalid) {
      creds.controls.forEach(element => {

        if (element.value.DocumentFile === '' || element.value.DocumentFile === null) {
          element.get('DocumentFile').markAsTouched();


        }
        element.get('StuSrNo').markAsTouched();
        if (element.value.HasExpiryDate == true) {

          element.get('StuDocExpiry').markAsTouched();
          element.get('StuDocIssue').markAsTouched();
        }
      })
      this.documentDetailsForm.get('StuRemarkCheck').markAsTouched();
    }
    else {
      if (this.tabs) {
        const lastTab: string = this.tabs.split(', ').pop() || '';
        if (this.tabName == lastTab) {
          const data = {};
          data['message'] = 'Are You Sure You Have Updated ' + this.tabs + ' Tabs. Do You Want To Proceed?';
          data['title'] = 'Alert';
          data['icon'] = 'fa fa-question';
          this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            if (result === 'yes') {

              this.Update();
              this.saveFiles();
            } else {
              this.dialogRef.close();

            }
          });
        }
        else {
          this.Update();
          this.saveFiles();
        }
      }
      else {
        this.Update();
        this.saveFiles();
      }

    }
  }

  Update() {
    this.spinner.show()
    let payload = this.documentDetailsForm.value;
    let iserror = false;
    payload['StuFileUpload'] = '';
    var bar = new Promise<void>((resolve, reject) => {
      payload.arrData.forEach((element, index, array) => {
        element.StuFileUpload = this.fileUploads[index];
        let da = element.StuDocIssue;
        let da1 = element.StuDocExpiry;
        let payload = {};
        payload['StuId'] = this.StudentPersonalId;
        payload['StuSrNo'] = element.StuSrNo;
        payload['StuDocumentName'] = element.DocumentName;
        payload['StuRemark'] = element.StuRemark;
        payload['StuFileUpload'] = element.DocumentName + '.pdf';
        payload['StuRemarkConfirm'] = this.documentDetailsForm.value.StuRemarkConfirm;
        payload['StuRemarkCheck'] = this.documentDetailsForm.value.StuRemarkCheck;
        payload['CoCode'] = this.CoId;
        payload['CgCode'] = this.CgId;
        payload['SessionId'] = this.session;
        payload['StuDocIssue'] = this.datepipe.transform(da, 'yyyy-MM-dd');
        payload['StuDocExpiry'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
        payload['StuDocId'] = this.SavedDocument[index].StuDocId;
        payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
        setTimeout(() => {
          this.umsService.updateDocumentDetails(payload).subscribe(res => {
            this.spinner.hide();
            if (res.status == false) {
              this.spinner.hide();
              iserror = true;
              this.errMsg = res.message;
            } else {
              this.spinner.hide();
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();

            this.documentDetailsForm.reset();
            this.fileUploader.nativeElement.value = null;
            this.printDisabled = false
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });

    })
    bar.then(() => {
      this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg;
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

        this.UpdScrtDetails();


        this.spinner.hide()
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    });
  }

  showbase64(e) {
    this.spinner.show();
    if (e.value.DocumentFile === null || e.value.DocumentFile == null || e.value.DocumentFile.startsWith('data:')) {
      this.spinner.hide()
      const dialogRef3 = this.dialog.open(PdfviewerComponent,
        {
          width: "400px",
          height: "500px",
          data: e.value.DocumentFile
        });
    } else {
      let payload = {};
      payload['StuId'] = this.StudentPersonalId;
      payload['fileNames'] = e.value.DocumentFile ? [e.value.DocumentFile] : [''];

      this.umsService.getFilesDetails(payload).subscribe((res) => {
        this.spinner.hide();
        this.umsService.disable6 = false;
        this.submitButton = false;
        this.updateButton = true;
        const files = res.files || [];
        const dialogRef3 = this.dialog.open(PdfviewerComponent,
          {
            width: "400px",
            height: "500px",
            data: res.files[0].base64Data,
            disableClose: true
          });
      });
    }


  }

  back() {
    this.prev.emit();
  }

  prepopulationOfAddmission() {
    this.spinner.show();
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.addmissionData = res.data[0];
        this.CoId = res.data[0].StuCoId;
        this.CgId = res.data[0].StuCgId;
        this.getExam(this.addmissionData.StuEmId);
        this.getExamStreamData(res.data[0].StuCoId, res.data[0].StuBrId)
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getExamStreamData(id, StrId) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data.length > 0) {
        res.data.forEach(element => {
          if (element.StrId == StrId) {
            // this.addmissionData.push({ "StrCode": element.StrCode });
            this.addmissionData.StuBrId = element.StrCode
          }
        });


      } else {
        // this.showchat = true;
      }

    },
    );
  }

  deletesemRow(index) {
    const creds = this.documentDetailsForm.controls.arrData as FormArray;
    creds.controls.forEach(element => {
      this.StuSrNum = element.value['StuSrNo'];
      this.StuDocName = element.value['StuDocumentName'];
      this.StuRmk = element.value['StuRemark'];

    })
    if (index !== 0 && (this.StuSrNum == '' && this.StuDocName == '' && this.StuRmk == '')) {
      (<FormArray>this.documentDetailsForm.get("arrData")).removeAt(index);
    }
    else {
      let data = {}
      data['message'] = "This Row Can Not Be Deleted"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

    }

  }

  getSecretData() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.InstId = res.projectPharam['ClubPartTrans'];
        this.activeFlowObject = res.projectPharam['ActiveFlow']
        this.arrActiveFlow = JSON.parse(this.activeFlowObject);
      }
      else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  Print() {
    let payload1 = {}
    payload1['StuId'] = sessionStorage.getItem('StudentPersonalId');
    payload1['RgNo'] = sessionStorage.getItem('StudentRGID');
    let jsonString = JSON.stringify(payload1).replace(/\\/g, '');

    var filter: any;
    filter = {

      "LoginId": parseInt(sessionStorage.getItem('StudentRGID')),
      "RptCode": 99,
      "InstName": '',
      "InstNo": this.InstId,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": parseInt(sessionStorage.getItem('StudentRGID')),
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": parseInt(sessionStorage.getItem('session')),
      "Extra1": JSON.stringify(payload1),
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('download-details')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  // onInputChange(val, index) {
  //   const tempData = val.target.value;
  //   const arrData = this.documentDetailsForm.get('arrData') as FormArray;
  //   const isDuplicate = this.stuSrNoArray.some((item: any) => item === tempData);
  //   // If it's not a duplicate, push the new item
  //   if (!isDuplicate) {
  //     this.stuSrNoArray[index] = tempData;
  //   }
  //   else if (isDuplicate) {
  //     arrData.controls[index].get('StuSrNo').setErrors({ Duplicate: true });
  //     arrData.controls[index].get('StuSrNo').setValue('')
  //   }


  // }
  onInputChange(event: Event, index: number) {
    const inputElement = event.target as HTMLInputElement;
    const tempData = inputElement.value;
    const arrData = this.documentDetailsForm.get('arrData') as FormArray;
    this.stuSrNoArray = arrData.controls.map((control, idx) => idx !== index ? control.get('StuSrNo').value : tempData);
    const isDuplicate = this.stuSrNoArray.filter((item, idx) => idx !== index).includes(tempData);
    if (isDuplicate) {
      arrData.controls[index].get('StuSrNo').setErrors({ Duplicate: true });
    } else {
      arrData.controls[index].get('StuSrNo').setErrors(null);
    }
  }

  issueDateValidation(item, i) {
    const currentIssueDate = item.value.StuDocIssue
    const formattedDate = currentIssueDate.toISOString().slice(0, 10);

    const currentExpireDate = item.value.StuDocExpiry
    const formattedExpiryDate = currentExpireDate.toISOString().slice(0, 10);

    if ((formattedExpiryDate != '' || formattedExpiryDate != null) && formattedDate > formattedExpiryDate) {
      let data = {}
      data['message'] = 'from Date should be less than expiry date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      let arr = this.documentDetailsForm.get('arrData') as FormArray
      arr.at(i).get('StuDocIssue').setValue('');
    }
  }

  toDateValidation(item, i) {
    if (item.value.StuDocIssue == null) {
      let data = {}
      data['message'] = 'Select First Issue Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      let arr = this.documentDetailsForm.get('arrData') as FormArray
      arr.at(i).get('StuDocExpiry').setValue('');
    }
    if (item.value.StuDocIssue == "") {
      let data = {}
      data['message'] = 'Select First Issue Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      let arr = this.documentDetailsForm.get('arrData') as FormArray
      arr.at(i).get('StuDocExpiry').setValue('');
    }
    else if (item.value.StuDocIssue > item.value.StuDocExpiry) {
      let data = {}
      data['message'] = 'Expiry Date should be greater than Issue Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      let arr = this.documentDetailsForm.get('arrData') as FormArray
      arr.at(i).get('StuDocExpiry').setValue('');
    }
  }


  NewCoSch() {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = this.CoId;
    payload['CShStatus'] = '';
    payload['LoginId'] = 0;
    payload['CShSnNo'] = this.session;
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        //step 6) if course is scheduled take its shid and check registration list
        this.spinner.hide()
        this.NewSearchCoSch(res.data[0]['CShId'])
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  NewSearchCoSch(ShId) {
    this.spinner.show()
    const payload = {};
    payload['CEcShId'] = ShId;
    this.umsService.NewSearchCoSch(payload).subscribe(res => {
      if (res.status) {
        //Step 7)registration list take its ecid and call registration api
        this.spinner.hide()
        this.RegnForm(res.data[0]['CEcId'])
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  RegnForm(EcId) {
    // if(this.ExamDtails['EmSrNo'] > 1){
    //   this.laterEntry = 'L'
    // }
    // else{
    //   this.laterEntry = ''
    // }
    this.spinner.show()
    // const SubValues = this.addmissionData['StuSubjectRg'].join(',').trim();
    let subjects = this.addmissionData['StuSubjectRg'];
    let result = (Array.isArray(subjects) ? subjects : [subjects]).join(',').trim();
    const payload = {};
    payload['CSExBr'] = '';
    payload['Code'] = '';
    payload['Colg'] = '';
    payload['valid'] = 'Y';
    payload['changed'] = '';
    payload['CgCodee'] = '';
    payload['Batch'] = '';
    payload['Name'] = this.PersonalDetails['StuFirstNameEng'];
    payload['RgNo'] = this.PersonalDetails['StuRgNo'];
    payload['FormNo'] = '';
    payload['CgCode'] = this.CgId;
    payload['Chng'] = 'Y';
    payload['Valid'] = '';
    payload['Father'] = this.PersonalDetails['StuMidNameEng'];
    payload['Mother'] = this.PersonalDetails['StuMothNameEng'] ? this.PersonalDetails['StuMothNameEng'] : '';
    payload['BirthDate'] = this.PersonalDetails['StuBirthDate'];
    payload['Sex'] = this.PersonalDetails['StuGender'];
    payload['Cate'] = 'R';
    payload['Caste'] = this.ReservationDetails['StuConstiSubCate'] ? this.ReservationDetails['StuConstiSubCate'] : '';     //this.Arr['StuConstiSubCate']
    payload['EMail'] = this.PersonalDetails['EmailID'] ? this.PersonalDetails['EmailID'] : '';
    payload['Medium'] = 'E';
    payload['Nation'] = '1';
    payload['Mobile'] = this.PersonalDetails['StuNumber'] ? this.PersonalDetails['StuNumber'] : '';
    payload['Addr1'] = this.addressDetails['StuAddrC'] ? this.addressDetails['StuAddrC'] : '';
    payload['Addr2'] = '';
    payload['Addr3'] = '';
    payload['Addr1P'] = this.addressDetails['StuAddrP'] ? this.addressDetails['StuAddrP'] : '';
    payload['Addr2P'] = '';
    payload['Addr3P'] = '';
    payload['Pin'] = this.addressDetails['StuPinC'] ? this.addressDetails['StuPinC'] : '';
    payload['PinP'] = this.addressDetails['StuPinP'] ? this.addressDetails['StuPinP'] : '';
    payload['Place'] = '';
    payload['StrCode'] = this.addmissionData['StuBrId'] ? this.addmissionData['StuBrId'] : 0;
    payload['PlaceP'] = '';
    payload['ExSub'] = '';
    payload['Sub'] = result;
    payload['EcId'] = EcId;
    payload['CoCode'] = this.CoId
    payload['SnNo'] = parseInt(this.session);
    payload['EmSrNoF'] = this.ExamDtails['EmSrNo'];
    payload['msg'] = '';
    payload['EmSkip'] = this.laterEntry; //this.laterEntry
    payload['StuId'] = this.PersonalDetails['StuId'];
    //from this.Arr all data of student should be inserted in payload
    this.umsService.addRegiFormScrutiny(payload).subscribe((res) => {
      if (res.status) {
        //step 8) if registration done successfully then call validate api
        this.spinner.hide()
        this.Validate(EcId);

      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      // this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  Validate(EcId) {
    //once validate api is called this student is considered as successfully inserted in registration table.
    this.spinner.show()
    const payload = {};
    payload['Batch'] = '';
    payload['EcId'] = EcId;
    payload['Inst'] = this.InstId;
    this.umsService.validateRegiForm(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.first.emit();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      // this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getPersonalDetails() {
    this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.PersonalDetails = res.data[0];
        this.getContactDetails(this.PersonalDetails)
        this.getReservationsDetails(this.PersonalDetails)
      } else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getContactDetails(Id) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = Id.StuId
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.addressDetails = res.data[0];
      } else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getReservationsDetails(Id) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = Id.StuId
    this.umsService.fetchReservationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.ReservationDetails = res.data[0];
      } else {
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  getExam(EmId) {
    this.spinner.show();
    let payload = {};
    payload['EmId'] = EmId
    this.umsService.fetchExam(payload).subscribe((res) => {
      this.ExamDtails = res.data[0];
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }

  save() {
    console.log('hiii')
    const creds = this.documentDetailsForm.get('arrData') as FormArray;
    if (creds.invalid || this.documentDetailsForm.invalid) {
      console.log('this.documentDetailsForm', this.documentDetailsForm)
      creds.controls.forEach(element => {
        if (element.value.HasExpiryDate == true) {
          element.get('StuDocExpiry').markAsTouched();
          element.get('StuDocIssue').markAsTouched();

        }
        if (element.value.IsRequired == 1) {
          element.get('DocumentFile').markAsTouched();
          element.get('StuSrNo').markAsTouched();
        }
      })
      this.documentDetailsForm.get('StuRemarkCheck').markAsTouched();
    }
    else {
      this.spinner.show()
      let payload = this.documentDetailsForm.value;
      let iserror = false;
      payload['StuFileUpload'] = '';
      var bar = new Promise<void>((resolve, reject) => {
        payload.arrData.forEach((element, index, array) => {
          element.StuFileUpload = this.fileUploads[index];
          let payload = {};
          let da = element.StuDocIssue;
          let da1 = element.StuDocExpiry;
          payload['StuId'] = this.StudentPersonalId;
          payload['StuSrNo'] = element.StuSrNo;
          payload['StuDocumentName'] = element.DocumentName;
          payload['StuRemark'] = element.StuRemark;
          payload['StuFileUpload'] = element.DocumentName + '.pdf';
          payload['StuRemarkConfirm'] = this.documentDetailsForm.value.StuRemarkConfirm;
          payload['StuRemarkCheck'] = this.documentDetailsForm.value.StuRemarkCheck;
          payload['CoCode'] = this.CoId;
          payload['CgCode'] = this.CgId;
          payload['SessionId'] = this.session;
          payload['StuDocIssue'] = this.datepipe.transform(da, 'yyyy-MM-dd');
          payload['StuDocExpiry'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
          payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
          setTimeout(() => {
            this.umsService.addDocumentDetails(payload).subscribe(res => {
              this.spinner.hide();
              if (res.status == false) {
                this.spinner.hide()
                iserror = true;
                this.errMsg = res.message;
              } else {
                this.spinner.hide()
                iserror = false;
                this.errMsg = res.message;
              }
              if (index === array.length - 1) resolve();
              this.documentDetailsForm.reset();
              this.fileUploader.nativeElement.value = null;
              this.printDisabled = false
            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              iserror = true;
              this.errMsg = ERROR.error.message;
              if (index === array.length - 1) resolve();
            });
          }, index * 2000);
        });
        this.saveApplicationDetails();
      })
      bar.then(() => {
        this.spinner.hide();
        if (iserror == false) {
          this.spinner.hide();
          this.AddScrtDetails1();
          let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = this.errMsg
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

        }
      });

    }
  }

  submitStudentDetails() {
    console.log(this.arrActiveFlow);
    if (this.arrActiveFlow[0]['FeesBeforeScrutiny'] == 1) {
      console.log("inside if");
      this.saveWithScrutiny();
      this.saveFiles()
    }
    else if (this.arrActiveFlow[0]['FeesBeforeScrutiny'] == 0) {
      console.log("inside else");
      this.save();
      this.saveFiles();
    }

  }





  saveWithScrutiny() {
    const creds = this.documentDetailsForm.get('arrData') as FormArray;
    if (creds.invalid || this.documentDetailsForm.invalid) {
      creds.controls.forEach(element => {
        if (element.value.HasExpiryDate == true) {
          element.get('StuDocExpiry').markAsTouched();
          element.get('StuDocIssue').markAsTouched();

        }
        if (element.value.IsRequired == 1) {
          element.get('DocumentFile').markAsTouched();
          element.get('StuSrNo').markAsTouched();
        }
      })
      this.documentDetailsForm.get('StuRemarkCheck').markAsTouched();
    }
    else {
      this.spinner.show()
      let payload = this.documentDetailsForm.value;
      let iserror = false;
      payload['StuFileUpload'] = '';
      var bar = new Promise<void>((resolve, reject) => {
        payload.arrData.forEach((element, index, array) => {
          element.StuFileUpload = this.fileUploads[index];
          let payload = {};
          let da = element.StuDocIssue;
          let da1 = element.StuDocExpiry;
          payload['StuId'] = this.StudentPersonalId;
          payload['StuSrNo'] = element.StuSrNo;
          payload['StuDocumentName'] = element.DocumentName;
          payload['StuRemark'] = element.StuRemark;
          payload['StuFileUpload'] = element.DocumentName + '.pdf';
          payload['StuRemarkConfirm'] = this.documentDetailsForm.value.StuRemarkConfirm;
          payload['StuRemarkCheck'] = this.documentDetailsForm.value.StuRemarkCheck;
          payload['CoCode'] = this.CoId;
          payload['CgCode'] = this.CgId;
          payload['SessionId'] = this.session;
          payload['StuDocIssue'] = this.datepipe.transform(da, 'yyyy-MM-dd');
          payload['StuDocExpiry'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
          payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'));
          setTimeout(() => {
            this.umsService.addDocumentDetails(payload).subscribe(res => {
              this.spinner.hide();
              if (res.status == false) {
                this.spinner.hide()
                iserror = true;
                this.errMsg = res.message;
              } else {
                this.spinner.hide()
                iserror = false;
                this.errMsg = res.message;
              }
              if (index === array.length - 1) resolve();
              this.documentDetailsForm.reset();
              this.fileUploader.nativeElement.value = null;
              this.printDisabled = false
            }, (ERROR: HttpErrorResponse) => {
              this.spinner.hide()
              iserror = true;
              this.errMsg = ERROR.error.message;
              if (index === array.length - 1) resolve();
            });
          }, index * 2000);
        });
        this.saveApplicationDetails();

      })
      bar.then(() => {
        this.spinner.hide();
        if (iserror == false) {
          this.spinner.hide();

          this.AddScrtDetails();
          let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.AddScrtDetails();
          })
        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = this.errMsg
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

        }
      });

    }
  }


  saveFiles() {
    let payload2 = this.documentDetailsForm.value;
    let filesArray: any[] = [];
    payload2.arrData.forEach((element, index) => {
      element.StuFileUpload = this.fileUploads[index];
      filesArray.push({
        fileName: element.DocumentName + '.pdf',
        base64Data: element.StuFileUpload
      });
    });
    const payload = {
      StuId: parseInt(this.StudentPersonalId),
      files: filesArray
    };
    this.umsService.saveFilesDetails(payload).subscribe(
      (res) => {
        console.log('Files uploaded successfully', res);
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        console.error(error);
      }
    );
  }


}